import { Button, marginTop } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledButton = styled(Button) `
  ${marginTop(5)};
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
`;
